// CSV parsing for the social import paste box. Accepts the batch format
// the blog-to-LinkedIn workflow produces: a header row plus one row per
// post, with quoted multi-line bodies.
//
// Recognized headers (case-insensitive, first match wins):
//   body | post           -> body (required)
//   first_comment | firstcomment | comment -> firstComment
//   hook | hook_type | hooktechnique       -> hookType
//   title                                   -> title

export function parseCsv(text) {
  const rows = [];
  let row = [], field = '', inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"' && text[i + 1] === '"') { field += '"'; i++; }
      else if (ch === '"') inQuotes = false;
      else field += ch;
    } else if (ch === '"') inQuotes = true;
    else if (ch === ',') { row.push(field); field = ''; }
    else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && text[i + 1] === '\n') i++;
      row.push(field); field = '';
      if (row.some(c => c.trim() !== '')) rows.push(row);
      row = [];
    } else field += ch;
  }
  if (field !== '' || row.length) { row.push(field); if (row.some(c => c.trim() !== '')) rows.push(row); }
  return rows;
}

const HEADER_MAP = [
  [['body', 'post'], 'body'],
  [['first_comment', 'firstcomment', 'comment'], 'firstComment'],
  [['hook', 'hook_type', 'hooktype', 'hooktechnique', 'hook_technique'], 'hookType'],
  [['title'], 'title'],
];

// -> { posts: [{body, firstComment, hookType, title}], error? }
export function parsePostsCsv(text) {
  const rows = parseCsv(text.trim());
  if (rows.length < 2) return { posts: [], error: 'Need a header row plus at least one post row.' };
  const header = rows[0].map(h => h.trim().toLowerCase().replace(/\s+/g, '_'));
  const cols = {};
  for (const [aliases, key] of HEADER_MAP) {
    const idx = header.findIndex(h => aliases.includes(h));
    if (idx >= 0) cols[key] = idx;
  }
  if (cols.body === undefined) {
    return { posts: [], error: `No "body" or "post" column found (saw: ${header.join(', ')}).` };
  }
  const posts = rows.slice(1)
    .map(r => ({
      body: (r[cols.body] || '').trim(),
      firstComment: cols.firstComment !== undefined ? (r[cols.firstComment] || '').trim() || null : null,
      hookType: cols.hookType !== undefined ? (r[cols.hookType] || '').trim() || null : null,
      title: cols.title !== undefined ? (r[cols.title] || '').trim() || null : null,
    }))
    .filter(p => p.body);
  if (posts.length === 0) return { posts: [], error: 'No rows had a post body.' };
  return { posts };
}
